export const userConstants = {
	LOGIN: 'USER_LOGIN',
	LOGOUT: 'USER_LOGOUT',
	UPDATE_PLAN: 'UPDATE_PLAN',
	ACTIVE: 'ACTIVE',
	SET_ACCESS_TOKEN: 'SET_ACCESS',
}
